import { ViewportScroller } from '@angular/common';
import { AfterContentChecked, ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AnchorModel } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-corso-di-studi',
  templateUrl: './page-corso-di-studi.component.html',
  styleUrls: ['./page-corso-di-studi.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PageCorsoDiStudiComponent implements OnInit, AfterContentChecked, OnDestroy {

  @ViewChild('modalCorsi') modalCorsi: any;
  @ViewChild('modaleVideo') modaleVideo: any;
  @ViewChild('modalalDocenti') modalalDocenti: any;
  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() isSecondLevelUp: boolean = false;
  @Input() levelMenu: any;
  private onRouterEvent = new Subscription();
  public block: any;
  public idAnchor: string = '';
  public isLinkEsternal: boolean = false;
  public domainWebsite = environment.urlApi;
  public isSpinner: boolean = false;
  public isSpinnerModale: boolean = true;
  public isSpinnerStep2: boolean = false;
  public titlePage: string = '';
  public keywords: any[] = [];
  public areeTematiche: any[] = [];
  public dipartimenti: any[] = [];
  public truncatedText: string = '';
  public showMore: boolean = false;
  public luogo: string = '';
  public columnCTA: string = '';
  public offerta_formativa: any[] = [];
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public isExternalLink: boolean = false;
  public visibleHeight: number = 350;
  //MODALE CORSI
  public dataAttivitaDidattica: any;
  public contentModal: any;
  public valueSelected: string = '';
  public modalitaApprendimento: string = '';
  public partizione: any;
  public titleModal: string = '';
  //FORM-MODALE
  // public dataStep1: any;
  // public dataStep2: any;
  public dataSteps2: any = [];
  public isStep2: boolean = false;
  public formSelect!: FormGroup;
  public formSelectStep2!: FormGroup;
  //MODALE DOCENTI
  public allDocenti: any;
  //MODALE SHARE
  public onHoverShare: boolean = false;
  public active = 0;



  constructor(
    public nodeService: NodeService,
    public helpersService: HelpersService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private scroller: ViewportScroller,
    private router: Router,
    public navigationService: NavigationService,
    private cd: ChangeDetectorRef
  ) { }

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
    this.verifyAnchorLinkTagA();
  }

  ngOnInit(): void {
    this.getCorso();
    this.isSpinner = true;
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });
    this.openModalFromUrl();
    this.modalService.activeInstances.subscribe(res => {
      if (res && !res.length) {
        // this.dataStep2 = [];
        this.isStep2 = false;
        this.dataSteps2 = [];
        this.active = 0;
      }
    });
  }
  
  ngOnDestroy(): void {
    this.onRouterEvent.unsubscribe();
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    const boundingCollapse = document.getElementById('container-field-taxonomies')?.getBoundingClientRect();
    if ((boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width > 990) || 
        ((boundingCollapse && boundingCollapse.y < -420 && boundingCollapse.width > 767) && (boundingCollapse && boundingCollapse.y < -420 && boundingCollapse.width <= 989)) || 
        (boundingCollapse && boundingCollapse.y < -860 && boundingCollapse.width <= 767)) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }
  }

  private getCorso() {
    this.nodeService.getRestDocentiCorso(this.node.langcode[0].value, 'corso', this.node.nid[0].value, this.node.preview).subscribe(corso => {
      this.block = corso;
      this.isLinkExternal();
      this.setTruncatedText(corso.obiettivi_del_corso);
      let newLinkYoutube = corso.link_video_corso ? corso.link_video_corso.replace('https://youtu.be', 'https://www.youtube.com/embed') : '';
      newLinkYoutube = corso.link_video_corso ? corso.link_video_corso.replace('youtube.com/watch', 'youtube.com/embed') : '';
      this.block.iframe_video = `<iframe width="560" height="400" src="${newLinkYoutube}?controls=1&autoplay=1" title="${corso.classe_di_laurea}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      this.luogo = corso.città;
      if (this.node?.field_is_almost_full && this.node?.field_is_almost_full[0] && this.node?.field_is_almost_full[0].value) {
        const txtInClosure = this.helpersService.instant("CONTENT_TYPES.PAGE_CORSO_DI_STUDI.IN_CLOSURE")
        this.luogo = `${corso.città} (${txtInClosure})`;
      }
      this.setTaxonomies(corso);
      this.setColumnCTA(corso);
      for (let anno in corso.offerta_formativa_esse3) {
        const anno_di_riferimento: any = anno;
        const percorsi = corso.offerta_formativa_esse3[anno];
      
        const title = anno_di_riferimento.replace("_", " ").split(" ").reverse().join(" ");
        const newEntry: any = {
          anno_di_riferimento: title,
          result: []
        };
      
        for (let percorso of percorsi) {
          const nome_percorso = percorso.name;
          const teachings = percorso.teachings;
          const pdsCod = percorso.pdsCod;
      
          newEntry.result.push({
            nome_percorso,
            pdsCod,
            teachings
          });
        }
      
        this.offerta_formativa.push(newEntry);
      }      
      if (this.offerta_formativa && this.offerta_formativa.length) {
        this.isSpinnerModale = false;
      }
      this.isLinkEsternal = this.block.presidente_coordinatore.link ? this.nodeService.verifyLinkExternal(this.block.presidente_coordinatore.link) : false;
    });
  };

  private setTruncatedText(description: string): void {
    if (description.length > 1000) {
      this.truncatedText = description.substring(0, 1000) + '...';
    } else {
      this.truncatedText = description;
    }
  }

  public setYear(anno: any[]): string {
    return anno[0].aaOffId + '-' + (anno[0].aaOffId + 1)
  };

  private setTaxonomies(block: any) {
    if (block.tassonomia_keyword_tematiche) {
      this.keywords = this.getTassonomiaBlock(block.tassonomia_keyword_tematiche);
    }
    if (block.tassonomia_dipartimento) {
      this.dipartimenti = this.getTassonomiaBlock(block.tassonomia_dipartimento);
    }
    if (block.tassonomia_aree_tematiche) {
      this.areeTematiche = this.getTassonomiaBlock(block.tassonomia_aree_tematiche);
    }
  };

  private getTassonomiaBlock(tassonomie: any[]): any {
    let data: any[] = [];
    if (this.nodeService.taxonomies) {
      tassonomie.map((tassonomia: any) => {
        const dataTemp = this.nodeService.taxonomies.find((el: any) => el.term_id === tassonomia.target_id.toString());
        if (dataTemp) {
          data.push(dataTemp);
        }
      });
    }
    return data;
  };

  private setColumnCTA(block: any) {
    let countColumn: number[] = [];
    block.collegamento_offerta_prossimo_anno ? countColumn.push(0) : null;
    block.con_collegamento_offerta ? countColumn.push(0) : null;
    block.con_collegamento_docenti ? countColumn.push(0) : null;
    switch (countColumn.length) {
      case 3:
        this.columnCTA = 'col-12 col-lg-4';
        break;
      case 2:
        this.columnCTA = 'col-12 col-lg-6';
        break;
      default:
        this.columnCTA = 'col-12 col-lg-6 m-auto';
        break;
    }

  };

  public addNewAnchorItem(value: AnchorModel) {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  };

  public openModalCorsi(): void {
    this.modalService.dismissAll();
    this.modalService.open(this.modalCorsi, {
      scrollable: false,
      centered: true,
      size: 'xl'
    });
    this.isSpinnerModale = true;
  };

  public openModalVideo(): void {
    this.modalService.dismissAll();
    this.modalService.open(this.modaleVideo, {
      scrollable: false,
      centered: true,
      size: 'xl'
    });
    this.isSpinnerModale = true;
  };

  public getAttivitaDitatticaDettaglio(aaOffId: number, attivita_didattica_id: number, pdsCod: string, attivita_didattica_cod: string, percorso: string, labelTitleModal: string, cdsCod: string) {
    this.isStep2 = true;
    this.isSpinnerStep2 = false;
    const cds_cod = cdsCod ? cdsCod : this.block.cds_cod_esse3;
    this.nodeService.getAttivitaDidattica(this.node.langcode[0].value, aaOffId, attivita_didattica_id, cds_cod, pdsCod, attivita_didattica_cod, this.node.preview)
    .subscribe({
      next: (attivitaDidattica) => {
          this.active = 0;
          this.dataSteps2 = attivitaDidattica;
          if (attivitaDidattica && attivitaDidattica.length) {
            for (let data of attivitaDidattica) {
              data = {
                ...data,
                aa: Number(aaOffId),
                percorso: percorso !== 'comune' ? percorso : '',
                partizione: data.partizioni[0]
              };
            }
          }
          this.titleModal = labelTitleModal;
          // this.dataStep2 = {
          //   ...attivitaDidattica,
          //   aa: Number(aaOffId),
          //   percorso: percorso !== 'comune' ? percorso : ''
          // };
          // this.titleModal = labelTitleModal;
          // this.partizione = attivitaDidattica.partizioni[0];
          // this.formStep2();
      },
      error: () => {},
      complete: () => { 
        setTimeout(() => {
          this.isSpinnerStep2 = true;          
          setTimeout(() => {
            if (this.helpersService.isBrowser) {
              const container = document.getElementById("body_step2");
              if (container) {
                container.scrollIntoView();
              }
            }
          }, 200)
        }, 300);
      }
    });
  }

  private formStep2() {
    // this.formSelectStep2 = this.formBuilder.group({
    //   partizione_selezionata: new FormControl(this.dataStep2.partizioni[0])
    // });
    // const part = this.dataStep2.partizioni;
    // this.formSelectStep2.valueChanges.subscribe(res => {
    //   this.partizione = part.find((el: any) => el.nome_partizione === res.partizione_selezionata);
    // });
  }

  public resetBoolean() {
    this.isStep2 = false;
    this.isSpinnerStep2 = false;
  }

  public getAllDocentiCorso() {
    this.nodeService.getRestDocentiCorso(this.node.langcode[0].value, 'docenti-corso', this.node.nid[0].value, this.node.preview).subscribe(docenti => {
      this.allDocenti = docenti;
    });
    this.modalService.open(this.modalalDocenti, {
      scrollable: false,
      centered: true,
      size: 'xl'
    });
    this.isSpinnerModale = true;
  }

  public goToTarget() {
    let target = this.block.collegamento_offerta_prossimo_anno;
    target = target.trim();
    target.replace(/\s+/g, ' ');
    if (target) {
      this.scroller.scrollToAnchor(target);
    }
  }  

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private openModalFromUrl(): void{
    if (this.router.url.includes('#')) {
      this.anchorUrl(this.router.url);
    }
    this.onRouterEvent = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('#')) {
          this.anchorUrl(event.url);
        }
      }
    })
  }

  private anchorUrl(url?: string, anchor?: string ): void {
    let anchorID: string = '';
    if (anchor && anchor !== '') {
      anchorID = anchor;
    } else if (url && url !== '') {
      anchorID = url.split('#')[1];
    }
    if (anchorID) {
      setTimeout(() => {
        if (anchorID === 'offerta-formativa-in-corso') {
          this.openModalCorsi();
        }
        if (anchorID === 'docenti') {
          this.getAllDocentiCorso();
        }
      }, 500);
    }
  }

  private verifyAnchorLinkTagA(): void {
    if(this.helpersService.isBrowser) {
      const elements = document.querySelectorAll('a[href*="#"]');
      elements.forEach(element => {
        let routerLinkValue: any;
        if (element.hasAttribute('href')) {
          routerLinkValue = element.getAttribute('href');
          if (routerLinkValue.includes('#')) {
            element.removeAttribute('href');
            element.addEventListener('click' ,() => {
              this.anchorUrl(routerLinkValue);
            })
          }
        }
      });
    }
  }

  public isLinkExternal(): void {
    this.isExternalLink = this.block.valutazione_didattica.link ? this.helpersService.verifyLinkExternal(this.block.valutazione_didattica.link) : false;
  }

  public removeComunePrefix(nome_percorso: string): string {
    const prefix1 = "Comune - ";
    const prefix2 = "comune - ";
    if (nome_percorso.startsWith(prefix1)) {
      return nome_percorso.substring(prefix1.length);
    } else if (nome_percorso.startsWith(prefix2)) {
      return nome_percorso.substring(prefix2.length);
    }
    return nome_percorso;
  }

  public onClickDocente(docente: any) {
    this.modalService.dismissAll();
    const route = this.navigationService.splitUrlRouterLink(docente.link_a_pagina_docente).path; 
    const queryParams = this.navigationService.splitUrlRouterLink(docente.link_a_pagina_docente).queryParams;
    this.router.navigate([route], {queryParams: queryParams});
  }

  public formatHtml(htmlString: string) {
    return htmlString.replaceAll('\n','<br>');
  }
  
}
